import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ErrorLabel from "../../../../component/error_label";

import { useNavigate } from "react-router-dom";
import { actionForgotPasswordEmployerSendOtp, actionForgotPasswordEmployerVerifyOtp, resetForgotPasswordEmployerSendOtpResponse, resetForgotPasswordEmployerVerifyOtpResponse } from "../store";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../common/app_constant";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import { getNextScreen } from "../../../../utils";

const ForgotPasswordEmployer = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [screenMode, setscreenMode] = useState("sendotp");
  const [otp, setOTP] = useState();
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");  // State variable to store email
  const [timer, setTimer] = useState(60); // Initial timer value in seconds
  const [isTimerRunning, setIsTimerRunning] = useState(true);

  const {
    register,
    formState: { errors },
    handleSubmit,getValues
  } = useForm();

  //START forgotpswd Employer - api SEND(get) OTP- response
  const { forgotPasswordEmployerSendOtp } = useSelector(state => ({
    ...state.publicStore,
  }));

  const { forgotPasswordEmployerVerifyOtp }  = useSelector(state => ({
    ...state.publicStore,
  }))
  // END

  // Get OTP Button CLICK
  const onForgotPswdSendOtpSubmit = data => {
     setEmail(data.email); //Store the email in state
    dispatch(actionForgotPasswordEmployerSendOtp(data));
  };
  // END

  // Verify Buttton Click
  const onVerifyForgotPswdEmployerOTP = (data) => {
    dispatch(actionForgotPasswordEmployerVerifyOtp(data));
  };
  // END

  // api call on update ---- > when response is true
  // setGetOTP(true)

// Timer START

useEffect(() => {
  let countdown; // variable to hold the countdown interval

  // Function to document the timer every second
  const startTimer = () => {
    countdown = setInterval(() => {
      setTimer((prevTimer) => {
          if (prevTimer === 0) {
              clearInterval(countdown); // Stop the countdown when timer reaches 0
              setIsTimerRunning(false);
              return 60;  // Reset timer to initial value
          }
          return prevTimer -1; // Decrement timer by 1 second
      });
    }, 1000);
  };

  // Start the timer when isTimerRunning becomes true
  if (isTimerRunning) {
    startTimer();
  } else {
    clearInterval(countdown); // Clear interval if timer is not running
  }

  // Clean up function to clear the interval when component unmounts or when timer stops
  return () => clearInterval(countdown);
}, [isTimerRunning]);
  
// Timer END

  useEffect(() => {
    console.log("Forgot Password Send OTP Response:", forgotPasswordEmployerSendOtp);
    if (forgotPasswordEmployerSendOtp !== null) {
      dispatch(resetForgotPasswordEmployerSendOtpResponse);
      if (forgotPasswordEmployerSendOtp?.status === true) {
        setIsTimerRunning(true);
        setscreenMode("verifyotp");
      } else {
        toast.error(forgotPasswordEmployerSendOtp?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      }
    }
  }, [forgotPasswordEmployerSendOtp]);



  useEffect(() => {
    console.log("Forgot Password Verify OTP Response:", forgotPasswordEmployerVerifyOtp);
    // Rest of your code
  
      if (forgotPasswordEmployerVerifyOtp !== null){
     dispatch(resetForgotPasswordEmployerVerifyOtpResponse);
     if (forgotPasswordEmployerVerifyOtp?.status) {
      localStorage.setItem("userData", JSON.stringify(forgotPasswordEmployerVerifyOtp.data.userData));
       localStorage.setItem("token", JSON.stringify(forgotPasswordEmployerVerifyOtp.data.token));
       const decoded = jwtDecode(forgotPasswordEmployerVerifyOtp?.data?.token);
        getNextScreen(decoded?.role)
       
      //  alert("navigate")
         navigate("/employer-change-password");
         window.location.reload();
           // alert("hello",getVerifyLoginOtp?.data?.is_verified )
     }else{
       toast.error(forgotPasswordEmployerVerifyOtp?.message, {
         duration: TOAST_DURATION,
         position: TOAST_POSITION,
         style: {},
       });
     }
    }
   },[forgotPasswordEmployerVerifyOtp])
   
   
  

  return (
    <>
     <div className="container">
        <div className="row justify-content-center ">
          <div className="col-md-4 align-item-center mt-6">
            <div className="card">
              <div className="card-body">
                <p className="lead fw-bold text-secondary">
                  <span className="text-dark">Forgot Password</span>
                </p>
                {/* Enter Email For Forgot Passowrd  */}
                {screenMode === "sendotp" && (
                <div>
                  <form onSubmit={handleSubmit(onForgotPswdSendOtpSubmit)}>
                    <div class="form-group mb-2">
                      <label className="form-label" htmlFor="email">
                        Email ID
                      </label>
                      <input
                        type="text"
                        id="email"
                        name="email"
                        className="form-control form-control-lg"
                        placeholder="Enter a valid email id"
                        {...register("email", {
                          required: "This is required.",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "invalid email address",
                          },
                        })}
                      />
                      {errors.email && (
                        <ErrorLabel message={errors.email?.message} />
                      )}
                    </div>

                    <button type="submit" className="btn btn-primary w-100">
                      Get OTP
                    </button>
                  </form>
                </div>
                )}

                {/* Enter OTP  and verify for  forgot password */}
                {screenMode === "verifyotp" && (
                <div>
                  <form
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit(onVerifyForgotPswdEmployerOTP)}
                  >
                    <p className="lead fw-bold me-3 text-secondary mb-1">
                      <span className="text-dark h6">
                      OTP is sent to your Mobile Number
                      </span>
                    </p>
                    <div className="form-outline mb-3 mt-4">
                      <label className="form-label" htmlFor="otp">
                        Enter OTP
                      </label>
                      <div className="">
                        <input
                          className="form-control form-control-lg"
                          type="text"
                          id="otp"
                          name="otp"
                          value={otp}
                          onChange={event => setOTP(event.target.value)}
                          {...register("otp", {
                            required: "This is required.",
                          })}
                        />
                        {errors.otp && (
                          <ErrorLabel message={errors.otp?.message} />
                        )}
                        <input type="hidden" name="code" value="axis"></input>
                      </div>
                      {error && <p>{error}</p>}
                    </div>
                    <div>
                      <div className="text-center text-primary">
                        {!isTimerRunning && (
                             <a onClick={() => dispatch(actionForgotPasswordEmployerSendOtp({ email }))}>Resend OTP</a>
                        )}
                        {isTimerRunning && <p> Resend OTP in {timer} seconds</p>}
                      </div>
                  </div>

                    <div className="text-center text-lg-start mt-4">
                      <button type="submit" className="btn btn-primary w-100">
                        Verify OTP
                      </button>
                    </div>
                  </form>
                </div> 
                )
                        }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordEmployer;
